import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
  selector: "app-taas-hero-art",
  templateUrl: "./taas-hero-art.component.html",
  styleUrls: ["./taas-hero-art.component.css"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TaasHeroArtComponent {}
